import { Button, DataHeader, DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverPayRateGroup extends Layout {
    buttonAddPayRate: Button;
    buttonCollapseAll: Button;
    buttonExpandAll: Button;
    dataheaderDriverPayRateGroup: DataHeader;
    labelPayRate: Label;
    panelContent: Panel;
    sourceDrsPayrateGroup: DataSource;
    sourceDrsPayrateHeader: DataSource;
    tableDriverPayRates: Table;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
